
export function getBankInfoByCardNumber(cardNumber) {
    // حذف هر چیزی غیر از عدد
    const digits = cardNumber ? cardNumber.toString().replace(/\D/g, '') : '';

    if (digits.length < 4) {
        return null;
    }

    const first6 = digits.substring(0, 6);
    const first4 = digits.substring(0, 4);

    const banks = {
        "603799": { name: "بانک ملی ایران", file: "Melli.svg" }, 
        "589210": { name: "بانک سپه", file: "Sepah.svg" },
        "627381": { name: "بانک سپه (انصار سابق)", file: "Ansar.svg" },
        "636214": { name: "بانک سپه (حکمت سابق)", file: "Hekmat.svg" },
        "610433": { name: "بانک ملت", file: "Mellat.svg" },
        "991975": { name: "بانک ملت", file: "Mellat.svg" },
        "627353": { name: "بانک تجارت", file: "Tejarat.svg" },
        "585983": { name: "بانک تجارت", file: "Tejarat.svg" },
        "603769": { name: "بانک صادرات", file: "Saderat.svg" },
        "627648": { name: "بانک توسعه صادرات", file: "Tosee_Saderat.svg" },
        "621986": { name: "بانک سامان", file: "Saman.svg" },
        "502229": { name: "بانک پاسارگاد", file: "Pasargad.svg" },
        "639347": { name: "بانک پاسارگاد", file: "Pasargad.svg" },
        "622106": { name: "بانک پارسیان", file: "Parsian.svg" },
        "639194": { name: "بانک پارسیان", file: "Parsian.svg" },
        "627884": { name: "بانک پارسیان", file: "Parsian.svg" },
        "627412": { name: "بانک اقتصاد نوین", file: "Eghtesad_Novin.svg" },
        "627488": { name: "بانک کارآفرین", file: "Karafarin.svg" },
        "502938": { name: "بانک کارآفرین", file: "Karafarin.svg" },
        "603770": { name: "بانک کشاورزی", file: "Keshavarzi.svg" },
        "639217": { name: "بانک کشاورزی", file: "Keshavarzi.svg" },
        "628023": { name: "بانک مسکن", file: "Maskan.svg" },
        "589463": { name: "بانک رفاه کارگران", file: "Refah.svg" },
        "627760": { name: "پست بانک ایران", file: "Postbank.svg" },
        "502806": { name: "بانک شهر", file: "Shahr.svg" },
        "504706": { name: "بانک شهر", file: "Shahr.svg" },
        "504172": { name: "بانک رسالت", file: "Resalat.svg" },
        "606373": { name: "بانک مهر ایران", file: "Mehr_Iran.svg" },
        "636462": { name: "بانک آینده", file: "Ayandeh.svg" },
        "505785": { name: "بانک ایران زمین", file: "Iran_Zamin.svg" },
        "606256": { name: "موسسه ملل", file: "Melall.svg" },
        "627961": { name: "بانک صنعت و معدن", file: "Sanat_Madan.svg" },
        "505416": { name: "بانک گردشگری", file: "Gardeshgari.svg" },
        "505809": { name: "بانک خاورمیانه", file: "Khavar_Mianeh.svg" },
        "639607": { name: "بانک سرمایه", file: "Sarmayeh.svg" },
        "639346": { name: "بانک سینا", file: "Sina.svg" },
    };

    const bankData = banks[first6] || banks[first4];

    if (bankData) {
        try {
            return {
                name: bankData.name,
                logo: require(`@/assets/bankLogo/${bankData.file}`)
            };
        } catch (e) {
            console.error(`Logo for ${bankData.name} not found at @/assets/bankLogo/${bankData.file}`);
            return { name: bankData.name, logo: null };
        }
    }

    return null;
}